import Button from "components/Button/Button";
import RouterStore from "stores/RouterStore";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import UserStore from "stores/UserStore";
import VaultStore from "stores/VaultStore";
import RegeneratorActions from "./RegeneratorActions";
import "./GlobalActions.scss";
import NFTStore from "stores/NFTStore";
import EthStore from "stores/EthStore";

function GlobalActions() {
  const screenWidth = document.body.clientWidth;
  const hasBurger = screenWidth < 1024 ? true : false;
  const [showMenu, setShowMenu] = useState(false);
  if (hasBurger) {
    return (
      <div className="global-actions-menu">
        <div className="menu-toggle" onClick={() => setShowMenu((val) => !val)}>
          <b>MENU</b>
        </div>
        {showMenu && <ActionsContainer />}
      </div>
    );
  }
  return <ActionsContainer />;
}

const ActionsContainer = observer(() => {
  const allowances = UserStore.allowances.get("Router");

  let LINKAllowance = false;
  if (allowances) {
    const allowance = allowances.find((allowance) => allowance.tokenName === "LINK" && allowance.hasAllowance);
    if (allowance) {
      LINKAllowance = true;
    }
  }
  const { randomReady, lotteryTickets, lotteryInfo } = RouterStore;
  const { unclaimedLink } = NFTStore;
  const { currentBlock } = EthStore;
  const { epochStartBlock } = VaultStore;

  const blocksRemaining = epochStartBlock + 13500 - currentBlock;

  const canStartNewEpoch = blocksRemaining <= 0;

  return (
    <div className="side-item global-actions">
      <div className="section-title section-title-global-actions">Global actions</div>
      <Button type="positive" className="global-button" onClick={() => VaultStore.distributeFees()}>
        Distribute fees
      </Button>
      <Button
        type="positive"
        className={`global-button ${!canStartNewEpoch && "disabled"}`}
        onClick={() => canStartNewEpoch && VaultStore.startNewEpoch()}
      >
        Start a new epoch <br />
        {blocksRemaining} blocks remaining
      </Button>
      <div className="section-title section-title-global-actions">NFT Lottery round {lotteryInfo.currentLotteryRound}</div>
      {LINKAllowance && (
        <Button
          type="positive"
          className="global-button clickable link-button"
          style={{ backgroundColor: "hotpink" }}
          onClick={() => RouterStore.selfRequestRandomNumber()}
        >
          Generate lottery number
          <span style={{ fontSize: "12px" }}>(cost 2 LINK, reward NFT)</span>
        </Button>
      )}
      {unclaimedLink > 0 && (
        <Button
          type="positive"
          className="global-button clickable link-button"
          style={{ backgroundColor: "hotpink" }}
          onClick={() => RouterStore.claimLink()}
        >
          Claim LINK NFT reward!
        </Button>
      )}
      {!LINKAllowance && (
        <Button
          type="positive"
          className="global-button clickable"
          style={{ backgroundColor: "hotpink" }}
          onClick={() => UserStore.getAllowance("LINK", "Router")}
        >
          Approve LINK for RNG
        </Button>
      )}
      {/* <RegeneratorActions /> */}
      {lotteryTickets.userActive < 8 ? (
        <div className="lottery-info">
          <div className="flex-row">
            <Button type="positive" className="global-button disabled" style={{ backgroundColor: "green" }}>
              <span style={{ fontSize: "10px" }}>claimed: {lotteryTickets.userActive}</span>
            </Button>
            <Button type="positive" className="global-button disabled" style={{ backgroundColor: "green" }}>
              <span style={{ fontSize: "10px" }}>tickets: {lotteryTickets.userTotal}</span>
            </Button>
          </div>
          {lotteryTickets.userTotal > 0 && randomReady ? (
            <Button
              type="positive"
              className="global-button clickable"
              style={{ backgroundColor: "hotpink" }}
              onClick={() => RouterStore.claimTickets()}
            >
              Claim your tickets!
            </Button>
          ) : (
            lotteryTickets.userTotal > 0 && (
              <Button type="positive" className="global-button clickable disabled" style={{ backgroundColor: "green" }}>
                Generate RNG to claim! <br />
                <span style={{ fontSize: "9px" }}>(or wait for someone else to do it)</span>
              </Button>
            )
          )}
        </div>
      ) : (
        <div className="lottery-info">
          {" "}
          <Button type="positive" className="global-button disabled" style={{ backgroundColor: "green" }}>
            All tickets claimed!
          </Button>
        </div>
      )}
      <RegeneratorActions />
    </div>
  );
});

export default observer(GlobalActions);
